import { Flex, Typography, theme } from 'antd';
import { isSocialPlatform, Platform } from '@/types/api/platforms';

export const PercentageByPlatformTooltipContentEcho = ({
  label,
  value,
  selectedPlatform,
}: {
  label: string;
  value: number;
  selectedPlatform: Platform;
}) => {
  const { token } = theme.useToken();
  const isAllCombined = selectedPlatform.toLowerCase() === 'all combined';

  return (
    <Flex vertical>
      <Typography.Text
        style={{
          marginBottom: token.marginXS,
          fontSize: token.fontSizeSM,
          fontWeight: 500,
        }}
      >
        {label}
      </Typography.Text>
      <Typography.Text style={{ color: token.colorPrimary, fontWeight: 500 }}>
        {value}%
      </Typography.Text>
      <Flex vertical>
        <Typography.Text style={{ color: token.colorTextSecondary, fontSize: token.fontSizeSM }}>
          {isAllCombined
            ? 'of people viewing your content on YouTube, Instagram, and TikTok'
            : isSocialPlatform(selectedPlatform)
              ? 'of people viewing your content on'
              : 'of people listening to your audio podcast distributed by'}
        </Typography.Text>
        <Typography.Text style={{ fontSize: token.fontSizeSM, fontWeight: 500 }}>
          {isAllCombined ? 'all podcast players, YouTube, Instagram, TikTok' : selectedPlatform}
        </Typography.Text>
      </Flex>
      {selectedPlatform === Platform.Acast && (
        <Typography.Text
          style={{
            marginTop: token.marginXS,
            color: token.colorTextSecondary,
            fontSize: token.fontSizeSM,
          }}
        >
          This includes listens on all podcast players such as Spotify, Apple Podcast, Castbox,
          Pocket Casts, etc.
        </Typography.Text>
      )}
    </Flex>
  );
};
